import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import "./Login.scss";
import { useDispatch, useSelector } from "react-redux";
import { getTenantInfo } from "../../reducers/tenant";
import {
  getToken,
  loginAsync,
  getLoginStatus,
  updateLoginStatus,
} from "../../reducers/login";
import PropTypes from "prop-types";
import { getTenantName } from "../../reducers/app";
import { Toast } from "primereact/toast";
import { COMMON_STATUS, SEVERITY_STATUS } from "../../constants/status";
import { Footer } from "../../layout/Footer/Footer";
import { useTranslation } from "react-i18next";
import { useSetDeadline } from "../../customhooks/common";
import { LoginForm } from "../../components/Login/LoginForm";

type Props = {
  setToken: any;
};

export const Login: React.FC<Props> = (props: Props) => {
  const { t, i18n } = useTranslation("common");

  const client_info = useSelector(getTenantInfo);

  const deadline = useSetDeadline(client_info?.deadline);

  useEffect(() => {
    sessionStorage.setItem('page', 'login');
  },[]); 

  return (
    <div className="login-body p-2">
      <div className="login-wrapper">
        <div className="login-panel">
          <button className="logo p-link">
            <img src={client_info.logo} alt={client_info.name} loading="lazy" />
          </button>
          {!client_info.customMessageOrderDeadline && client_info.deadline && (
            <h6 className="text-pink-700 ">
              {t("DeadlineOrder")} {deadline}
            </h6>
          )}
          {client_info?.customMessageOrderDeadline && (
            <h5 className="text-pink-700">
              {client_info?.customMessageOrderDeadline}
            </h5>
          )}

          <LoginForm setToken={props.setToken} />
        </div>
        <Footer />
      </div>
    </div>
  );
};

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
